function showMess(_this, title, mess, icon, toast, time, noAutoHide = false) {
  _this.$bvToast.toast(mess, {
    title: title,
    autoHideDelay: time,
    variant: icon,
    toaster: toast,
    solid: true,
    appendToast: true,
    noAutoHide: noAutoHide,
  })
}

export const showMessError = (_this, mess, time = 0, title = 'Lỗi') => {
  showMess(_this, title, mess, 'danger', 'b-toaster-top-right', time, time <= 0)
}

// sử dụng cho catch
export const showMessErrorResponse = (_this, error, time = 0, title = 'Lỗi') => {
  const mess = error?.response?.data?.message || error?.response?.message || error.message
  showMessError(_this, mess, (time = 0), (title = 'Lỗi'))
}

export const showMessSuccess = (_this, mess, time = 3000, title = 'Thành công') => {
  showMess(_this, title, mess, 'success', 'b-toaster-top-right', time, time <= 0)
}

export { showMess }
